<template>
  <div class="app-browse-collections">
    <div class="container">
        <div class="row py-3 py-md-4">
            <div class="col-12 col-md-6 text-left">
                <h3 class="mb-0 mt-2 mt-md-3">All Gradient Collections</h3>
                <div class="text-muted">{{totalCollections}} collections and {{totalGradients}} unique gradients</div>
            </div>
            <div class="col-12 col-md-6 d-none d-md-block">
                <div class="btn-group btn-group-sm float-right mt-22">
                  <button 
                    v-for="filter in filters"
                    class="btn btn-outline-secondary"
                    :class="{ 'active': filter.value == activeFilter}"
                    :key="filter.value"
                    @click="activeFilter = filter.value"
                  >
                    {{filter.name}}
                  </button>
                </div>
            </div>
        </div>
        <collection-list :collectionType="activeFilter" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CollectionList from '@/components/CollectionList.vue';
import collections from '@/util/collections.js'
import gradients from '@/util/gradients.js'


export default {
  name: 'home',
  components: {
    CollectionList
  },
  metaInfo: {
    title: "All Gradient Collections | Gradient Magic",
    meta: [
        { 
            vmid:'description', name: 'description', 
            content: "View the entire library of CSS Gradients." 
        }
    ],
    link: [
        { vmid: 'canonical', rel: 'canonical', href: 'https://www.gradientmagic.com/browse'}
    ]
  },
  data(){
    return {
      filters: [
        { name: "Recently Created", value:"CREATED" },
        { name: "Most Popular", value:"POPULAR" },
        { name: "Premium", value:"PREMIUM" },
        // { name: "Recently Updated", value:"UPDATED" },
      ],
      activeFilter: "CREATED"
    }
  },
  computed: {
    totalCollections(){
      return collections.length;
    },
    totalGradients(){
      return gradients.length;
    }
  }
}
</script>

<style lang="scss">
.app-browse-collections {
  .mt-22 {
    margin-top: 2.5rem!important;
  }

}
</style>
